import React from 'react';

import MuiMenuItem from '@material-ui/core/MenuItem';
import MuiListItemIcon from '@material-ui/core/ListItemIcon';
import MuiListItemText from '@material-ui/core/ListItemText';

export default React.forwardRef(function MenuItem(props, ref)
{
  const {
    label,
    icon,
    ...rest
  } = props;

  return (
    <MuiMenuItem button ref={ref} {...rest}>
      <MuiListItemIcon>
        {icon}
      </MuiListItemIcon>
      <MuiListItemText>
        {label}
      </MuiListItemText>                
    </MuiMenuItem>
  );
});